import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Container, Alert } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import VerifyIdentity from '../../Components/VerifyIdentity/VerifyIdentity';
import { sendVerificationCode } from '../../Api/index.ts';

// Canadian University Email Domains
const CANADIAN_UNIVERSITY_DOMAINS = [
  // Ontario - Major Universities
  'utoronto.ca', 'mail.utoronto.ca', 'alumni.utoronto.ca', 'alum.utoronto.ca', 'alumni.u-toronto.ca',
  'queensu.ca', 'queens.ca', 'alumni.queensu.ca',
  'uwaterloo.ca', 'waterloo.ca', 'alumni.uwaterloo.ca',
  'mcmaster.ca', 'alumni.mcmaster.ca',
  'uwo.ca', 'westernu.ca', 'alumni.uwo.ca',
  'yorku.ca', 'york.ca', 'alumni.yorku.ca',
  'ryerson.ca', 'torontomu.ca', 'alumni.torontomu.ca',
  'uottawa.ca', 'ottawa.ca', 'alumni.uottawa.ca',
  'carleton.ca', 'cmail.carleton.ca', 'alumni.carleton.ca',
  'laurentian.ca', 'laurentianu.ca', 'alumni.laurentian.ca',
  'lakeheadu.ca', 'lakehead.ca', 'alumni.lakeheadu.ca',
  'trentu.ca', 'trent.ca', 'alumni.trentu.ca',
  'wlu.ca', 'laurier.ca', 'alumni.wlu.ca',
  'uoguelph.ca', 'guelph.ca', 'alumni.uoguelph.ca',
  'brocku.ca', 'brock.ca', 'alumni.brocku.ca',
  'nipissingu.ca', 'nipissing.ca', 'alumni.nipissingu.ca',
  'ontariotechu.ca', 'alumni.ontariotechu.ca',
  'uwinindsor.ca', 'uwindsor.ca', 'alumni.uwindsor.ca',
  'algomau.ca', 'algoma.ca', 'alumni.algomau.ca',
  
  // Ontario - Colleges & Specialized
  'ocad.ca', 'ocadu.ca', 'alumni.ocadu.ca',
  'redeemer.ca', 'redeemeru.ca', 'alumni.redeemer.ca',
  'tyndale.ca', 'tyndaleu.ca', 'alumni.tyndale.ca',
  'uofkings.ca', 'ukings.ca', 'alumni.kings.uwo.ca',
  'stjeromes.ca', 'stjeromesu.ca', 'alumni.stjeromes.ca',
  'stpauls.ca', 'ustpaul.ca', 'alumni.ustpaul.ca',
  'trinity.utoronto.ca', 'alumni.trinity.utoronto.ca',
  'vic.utoronto.ca', 'alumni.vic.utoronto.ca',
  'new.utoronto.ca', 'alumni.new.utoronto.ca',
  'innis.utoronto.ca', 'alumni.innis.utoronto.ca',
  'woodsworth.utoronto.ca', 'alumni.woodsworth.utoronto.ca',
  'stmikes.utoronto.ca', 'alumni.stmikes.utoronto.ca',
  'uc.utoronto.ca', 'alumni.uc.utoronto.ca',
  'stgeorge.utoronto.ca', 'alumni.stgeorge.utoronto.ca',
  'utsc.utoronto.ca', 'alumni.utsc.utoronto.ca',
  'utmiss.utoronto.ca', 'alumni.utmiss.utoronto.ca',
  
  // British Columbia - Major Universities
  'ubc.ca', 'alumni.ubc.ca', 'alum.ubc.ca',
  'sfu.ca', 'alumni.sfu.ca',
  'uvic.ca', 'alumni.uvic.ca',
  'unbc.ca', 'alumni.unbc.ca',
  'royalroads.ca', 'alumni.royalroads.ca',
  'twu.ca', 'alumni.twu.ca',
  
  // British Columbia - Colleges & Polytechnics
  'ufv.ca', 'alumni.ufv.ca',
  'capilanou.ca', 'alumni.capilanou.ca',
  'ecuad.ca', 'alumni.ecuad.ca',
  'kpu.ca', 'alumni.kpu.ca',
  'langara.ca', 'alumni.langara.ca',
  'nic.bc.ca', 'alumni.nic.bc.ca',
  'nvit.ca', 'alumni.nvit.ca',
  'okanagan.bc.ca', 'alumni.okanagan.bc.ca',
  'selkirk.ca', 'alumni.selkirk.ca',
  'tru.ca', 'alumni.tru.ca',
  'vcc.ca', 'alumni.vcc.ca',
  'viu.ca', 'alumni.viu.ca',
  
  // Alberta - Major Universities
  'ualberta.ca', 'alumni.ualberta.ca',
  'ucalgary.ca', 'alumni.ucalgary.ca',
  'uofc.ca', 'alumni.uofc.ca',
  'athabascau.ca', 'alumni.athabascau.ca',
  'concordia.ab.ca', 'alumni.concordia.ab.ca',
  
  // Alberta - Colleges & Polytechnics
  'macewan.ca', 'alumni.macewan.ca',
  'mtroyal.ca', 'alumni.mtroyal.ca',
  'nait.ca', 'alumni.nait.ca',
  'norquest.ca', 'alumni.norquest.ca',
  'oldscollege.ca', 'alumni.oldscollege.ca',
  'reddeerpolytech.ca', 'alumni.reddeerpolytech.ca',
  'sait.ca', 'alumni.sait.ca',
  
  // Quebec - Major Universities
  'mcgill.ca', 'alumni.mcgill.ca',
  'umontreal.ca', 'alumni.umontreal.ca',
  'ulaval.ca', 'alumni.ulaval.ca',
  'uqam.ca', 'alumni.uqam.ca',
  'concordia.ca', 'alumni.concordia.ca',
  'bishops.ca', 'alumni.bishops.ca',
  'etsmtl.ca', 'alumni.etsmtl.ca',
  'hec.ca', 'alumni.hec.ca',
  'inrs.ca', 'alumni.inrs.ca',
  'polymtl.ca', 'alumni.polymtl.ca',
  'uqtr.ca', 'alumni.uqtr.ca',
  'usherbrooke.ca', 'alumni.usherbrooke.ca',
  'cegep.qc.ca', 'alumni.cegep.qc.ca',
  
  // Nova Scotia - Major Universities
  'dal.ca', 'alumni.dal.ca',
  'acadiau.ca', 'alumni.acadiau.ca',
  'cbu.ca', 'alumni.cbu.ca',
  'msvu.ca', 'alumni.msvu.ca',
  'nscad.ca', 'alumni.nscad.ca',
  'nscc.ca', 'alumni.nscc.ca',
  'stfx.ca', 'alumni.stfx.ca',
  
  // New Brunswick - Major Universities
  'unb.ca', 'alumni.unb.ca',
  'mta.ca', 'alumni.mta.ca',
  'stthomasu.ca', 'alumni.stthomasu.ca',
  'nbcc.ca', 'alumni.nbcc.ca',
  
  // Manitoba - Major Universities
  'umanitoba.ca', 'alumni.umanitoba.ca',
  'uwinnipeg.ca', 'alumni.uwinnipeg.ca',
  'brandonu.ca', 'alumni.brandonu.ca',
  'rrc.ca', 'alumni.rrc.ca',
  
  // Saskatchewan - Major Universities
  'usask.ca', 'alumni.usask.ca',
  'uregina.ca', 'alumni.uregina.ca',
  'saskpolytech.ca', 'alumni.saskpolytech.ca',
  
  // Newfoundland and Labrador
  'mun.ca', 'alumni.mun.ca',
  'cna.nl.ca', 'alumni.cna.nl.ca',
  
  // Prince Edward Island
  'upei.ca', 'alumni.upei.ca',
  'hollandcollege.com', 'alumni.hollandcollege.com',
  
  // Northwest Territories
  'aurora-college.nt.ca', 'alumni.aurora-college.nt.ca',
  
  // Nunavut
  'arcticcollege.ca', 'alumni.arcticcollege.ca',
  
  // Yukon
  'yukoncollege.yk.ca', 'alumni.yukoncollege.yk.ca',
  
  // Additional common variations and legacy domains
  'student.ca', 'alumni.student.ca',
  'edu.ca', 'alumni.edu.ca',
  'academic.ca', 'alumni.academic.ca',
  'university.ca', 'alumni.university.ca',
  'college.ca', 'alumni.college.ca',
  'institute.ca', 'alumni.institute.ca',
  'polytechnic.ca', 'alumni.polytechnic.ca',
  'cegep.ca', 'alumni.cegep.ca',
  
  // Legacy and alternative domains
  'alum.ca', 'alumni.alum.ca',
  'graduate.ca', 'alumni.graduate.ca',
  'formerstudent.ca', 'alumni.formerstudent.ca',
  'exstudent.ca', 'alumni.exstudent.ca',
  'paststudent.ca', 'alumni.paststudent.ca'
];

export default function CreateAccount() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    school: 'Carleton University'
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showVerification, setShowVerification] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.first_name.trim()) {
      newErrors.first_name = 'First name is required';
    }
    
    if (!formData.last_name.trim()) {
      newErrors.last_name = 'Last name is required';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else {
      const emailDomain = formData.email.split('@')[1];
      if (!emailDomain || !CANADIAN_UNIVERSITY_DOMAINS.includes(emailDomain.toLowerCase())) {
        newErrors.email = 'Email must be from a valid Canadian university domain';
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleCreateAccount = async () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setErrorMessage('');

    try {
      console.log('Sending formData to backend:', formData);
      const response = await sendVerificationCode(formData);
      
      if (response.error) {
        setErrorMessage(response.error);
      } else {
        setShowVerification(true);
      }
    } catch (error) {
      setErrorMessage('Failed to send verification code. Please try again.');
      console.error('Error sending verification code:', error);
    } finally {
      setLoading(false);
    }
  };

  if (showVerification) {
    return (
      <VerifyIdentity 
        email={formData.email}
        formData={formData}
        onVerify={() => {
          navigate('/dashboard');
        }}
        onResend={handleCreateAccount}
        onGoBack={() => setShowVerification(false)}
      />
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 8, display: 'flex' }}>
      {/* Left Side - Hidden on mobile */}
      <Box sx={{ 
        flex: 1, 
        pr: 8,
        display: { xs: 'none', md: 'block' }
      }}>
        <Typography variant="h3" sx={{ 
          fontWeight: 'bold', 
          mb: 4, 
          fontSize: { xs: '2rem', md: '2.5rem' },
          color: '#000000'
        }}>
          Buy, Sell Textbooks with Ease—Connecting Students for a More Affordable Education!
        </Typography>

        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 3 }}>
          <Box sx={{ 
            color: '#6B89FF', 
            fontSize: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'rgba(107, 137, 255, 0.1)',
            boxShadow: '0 2px 8px rgba(107, 137, 255, 0.2)'
          }}>✓</Box>
          <Typography variant="h6" sx={{ 
            fontSize: { xs: '1.1rem', md: '1.3rem' },
            fontWeight: '500',
            color: '#2c3e50'
          }}>
            10,000+ textbooks available for exchange
          </Typography>
        </Box>

        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 3 }}>
          <Box sx={{ 
            color: '#6B89FF', 
            fontSize: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'rgba(107, 137, 255, 0.1)',
            boxShadow: '0 2px 8px rgba(107, 137, 255, 0.2)'
          }}>✓</Box>
          <Typography variant="h6" sx={{ 
            fontSize: { xs: '1.1rem', md: '1.3rem' },
            fontWeight: '500',
            color: '#2c3e50'
          }}>
            Buy and sell textbooks directly with fellow students
          </Typography>
        </Box>

        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 3 }}>
          <Box sx={{ 
            color: '#6B89FF', 
            fontSize: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'rgba(107, 137, 255, 0.1)',
            boxShadow: '0 2px 8px rgba(107, 137, 255, 0.2)'
          }}>✓</Box>
          <Typography variant="h6" sx={{ 
            fontSize: { xs: '1.1rem', md: '1.3rem' },
            fontWeight: '500',
            color: '#2c3e50'
          }}>
            Get the books you need for less—no middleman, no hassle
          </Typography>
        </Box>
      </Box>

      {/* Right Side - Full width on mobile */}
      <Box sx={{ 
        flex: 1,
        width: { xs: '100%', md: 'auto' }
      }}>
        <Typography variant="h4" sx={{ 
          mb: 1, 
          fontWeight: 'bold', 
          textAlign: 'center',
          color: '#000000'
        }}>
          Create Account
        </Typography>
        <Typography sx={{ 
          mb: 4, 
          textAlign: 'center',
          color: '#666',
          fontSize: '1.1rem'
        }}>
          to your bookloop account
        </Typography>

        {errorMessage && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
        )}

        <Box component="form" sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: 3,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          padding: 3,
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(107, 137, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(107, 137, 255, 0.1)'
        }}>
          <Box sx={{ height: '56px' }}>
            <TextField
              fullWidth
              label="First Name"
              variant="outlined"
              placeholder="Enter your first name"
              value={formData.first_name}
              onChange={(e) => handleInputChange('first_name', e.target.value)}
              error={!!errors.first_name}
              helperText={errors.first_name || " "}
              sx={{
                '& .MuiFormHelperText-root': {
                  position: 'absolute',
                  bottom: '-20px',
                }
              }}
            />
          </Box>

          <Box sx={{ height: '56px' }}>
            <TextField
              fullWidth
              label="Last Name"
              variant="outlined"
              placeholder="Enter your last name"
              value={formData.last_name}
              onChange={(e) => handleInputChange('last_name', e.target.value)}
              error={!!errors.last_name}
              helperText={errors.last_name || " "}
              sx={{
                '& .MuiFormHelperText-root': {
                  position: 'absolute',
                  bottom: '-20px',
                }
              }}
            />
          </Box>

          <Box sx={{ height: '56px' }}>
            <TextField
              fullWidth
              label="University Email"
              variant="outlined"
              type="email"
              placeholder="yourname@university.ca"
              value={formData.email}
              onChange={(e) => handleInputChange('email', e.target.value)}
              error={!!errors.email}
              helperText={errors.email || "Must be a valid Canadian university email"}
              sx={{
                '& .MuiFormHelperText-root': {
                  position: 'absolute',
                  bottom: '-20px',
                }
              }}
            />
          </Box>

          <Button
            variant="contained"
            sx={{
              mt: 3,
              background: 'linear-gradient(135deg, #6B89FF 0%, #5A75E6 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5A75E6 0%, #4A65D6 100%)',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(107, 137, 255, 0.3)'
              },
              textTransform: 'none',
              borderRadius: '30px',
              height: '56px',
              fontSize: '18px',
              fontWeight: '600',
              width: '250px',
              display: 'block',
              mx: 'auto',
              boxShadow: '0 4px 15px rgba(107, 137, 255, 0.2)',
              transition: 'all 0.3s ease',
              '&:disabled': {
                backgroundColor: '#ccc',
                transform: 'none',
                boxShadow: 'none'
              }
            }}
            onClick={handleCreateAccount}
            disabled={loading}
          >
            {loading ? 'Sending Code...' : 'Send Verification Code'}
          </Button>

          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Typography sx={{ mb: 1 }}>
              Already have an account? <Link to="/login" style={{ color: '#6B89FF', textDecoration: 'none' }}>Sign in</Link>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
} 